// import React from "react";
// import Colors from "Constants/Color";

// interface OrderStatusBadgeProps {
//   status: string;
//   color?: string;
//   fontSize?: string;
//   padding?: string;
//   borderRadius?: string;
// }

// const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
//   status,
//   color,
//   fontSize = "11px",
//   padding = "2px 8px",
//   borderRadius = "4px",
// }) => {
//   // Function to determine color based on status if color is not provided
//   const getStatusColor = (statusValue: string): any => {
//     if (color) {
//       return color;
//     }

//     const lowerStatus = statusValue?.toLowerCase() || "";

//     // Handle order_status values
//     if (lowerStatus === "pending dispatch") {
//       return {bg:Colors?.rnet_light_yellow,color:Colors?.rnet_dark_yellow};
//     }
//     if (lowerStatus === "cancelled") {
//       return {bg:Colors?.rnet_light_red,color:Colors?.rnet_dark_red};
//     }
//     if (lowerStatus === "partially cancelled") {
//       return {bg:Colors?.rnet_light_red_pastel,color:Colors?.rnet_dark_red_pastel};
//     }
//     if (lowerStatus === "partially dispatched") {
//       return {bg:Colors?.rnet_light_green_pastel,color:Colors?.rnet_dark_green_pastel};
//     }

//     // Handle order_item_status values
//     if (lowerStatus === "created" || lowerStatus === "dispatched" ||  lowerStatus === "pos") {
//       return {bg:Colors?.rnet_light_plural,color:Colors?.rnet_dark_plural};
//     }
//     if (lowerStatus === "requested for dispatch" || lowerStatus === "delivered" || lowerStatus === "order") {
//       return {bg:Colors?.rnet_light_blue,color:Colors?.rnet_dark_blue};
//     }

//     // Default fallback
//     return {bg:'#9E9E9E',color:'#000'};;
//   };

//   return (
//     <span
//       style={{
//         backgroundColor: getStatusColor(status)?.bg,
//         color: getStatusColor(status)?.color,
//         padding,
//         borderRadius,
//         fontSize,
//         textTransform: "capitalize",
//       }}
//     >
//       {status || "-"}
//     </span>
//   );
// };

// export default OrderStatusBadge;

import React from "react";
import Colors from "Constants/Color";
import { Chip } from "@mui/material";

interface OrderStatusBadgeProps {
  status: string;
  color?: string;
  fontSize?: string;
  padding?: string;
  borderRadius?: string;
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
  status,
  color,
  fontSize = "11px",
  padding = "2px 8px",
  borderRadius = "4px",
}) => {
  // Function to determine color based on status if color is not provided
  const getStatusColor = (statusValue: string): any => {
    if (color) {
      return color;
    }

    const lowerStatus = statusValue?.toLowerCase() || "";

    // Handle order_status values
    if (lowerStatus === "pending dispatch") {
      return {bg:Colors?.rnet_light_yellow,color:Colors?.rnet_dark_yellow};
    }
    if (lowerStatus === "cancelled") {
      return {bg:Colors?.rnet_light_red,color:Colors?.rnet_dark_red};
    }
    if (lowerStatus === "partially cancelled") {
      return {bg:Colors?.rnet_light_red_pastel,color:Colors?.rnet_dark_red_pastel};
    }
    if (lowerStatus === "partially dispatched") {
      return {bg:Colors?.rnet_light_green_pastel,color:Colors?.rnet_dark_green_pastel};
    }

    // Handle order_item_status values
    if (lowerStatus === "created" || lowerStatus === "dispatched" ||  lowerStatus === "pos") {
      return {bg:Colors?.rnet_light_plural,color:Colors?.rnet_dark_plural};
    }
    if (lowerStatus === "requested for dispatch" || lowerStatus === "delivered" || lowerStatus === "order") {
      return {bg:Colors?.rnet_light_blue,color:Colors?.rnet_dark_blue};
    }

    // Handle scan status values
    if (lowerStatus === "scanned") {
      return {bg:Colors?.rnet_light_green_pastel,color:Colors?.rnet_dark_green_pastel};
    }
    if (lowerStatus === "not scanned") {
      return {bg:'#E9ECEF',color:'#6C757D'};
    }
    if (lowerStatus === "verified") {
      return {bg:Colors?.rnet_light_green_pastel,color:Colors?.rnet_dark_green_pastel};
    }
    if (lowerStatus === "not verified") {
      return {bg:Colors?.rnet_light_red,color:Colors?.rnet_dark_red};
    }

    // Default fallback
    return {bg:'#9E9E9E',color:'#000'};;
  };
  let isOutlined=false;
  let size = "small"
  const isSmall = fontSize === "11px";
  const label = status || "-";
  const borderColor = getStatusColor(status)?.color || "#000";
  return (
    <Chip
      label={label}
      style={{
        background: isOutlined ? "transparent" : getStatusColor(status)?.bg,
        color: getStatusColor(status)?.color,
        border: `1.5px solid ${borderColor}`,
        height: isSmall ? "28px" : "32px",
        fontSize: isSmall ? "11px" : "12px",
        padding: isSmall ? "0 10px" : "0 12px",
        borderRadius: "16px",
        fontWeight: 500,
        fontFamily: `"Poppins", sans-serif`,
        textTransform: "capitalize",
        transition: "all 0.2s ease",
        boxShadow: isOutlined ? "none" : "0 1px 2px rgba(0,0,0,0.05)",
      }}
      size={"small"}
      variant={isOutlined ? "outlined" : "filled"}
    />
  );
};

export default OrderStatusBadge;

